import listActions from 'src/modules/division/list/divisionListActions';
import DivisionService from 'src/modules/division/divisionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'DIVISION_DESTROY';

const divisionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: divisionDestroyActions.DESTROY_STARTED,
      });

      await DivisionService.destroyAll([id]);

      dispatch({
        type: divisionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.division.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/division');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: divisionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: divisionDestroyActions.DESTROY_ALL_STARTED,
      });

      await DivisionService.destroyAll(ids);

      dispatch({
        type: divisionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.division.destroyAll.success'),
      );

      getHistory().push('/division');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: divisionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default divisionDestroyActions;
